import LocalizedStrings from 'react-localization';
import vn from './language/vn.json';

const strings = new LocalizedStrings({
  vn: vn
});

export default strings;
